module.exports = __webpack_public_path__ + "img/placeList4.414122ff.png";